var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWaterSource = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 34,
    viewBox: "0 0 20 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.175 1.6c-.232-.379-.644-.61-1.088-.61-.443 0-.855.231-1.087.61-4.2 6-9 14.4-9 19.95C0 27.725 4.625 33.5 10 33.5s10-5.775 10-11.95c0-5.7-4.575-13.8-8.825-19.95z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaterSource, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/water-source.dcc1ecd9.svg";
export { ForwardRef as ReactComponent };